import React, { Component } from 'react';
import { ShipGroups } from './componentChildren/ShipGroups';
import { RepickPutaway } from './componentChildren/RepickPutaway';
import './css/SessionSummary.css'

export class SessionSummary extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var sessionSummaryInfo = this.props.sessionSummaryInfo;
        var shipGroups = sessionSummaryInfo.shipGroups;
        var repicks = sessionSummaryInfo.repicks;
        for (var i in shipGroups) {
            if (shipGroups[i].orders) {
                shipGroups[i].orders = shipGroups[i].orders.sort(function (a, b) {
                    var slotA = a.slot.split("-")[1];
                    var slotB = b.slot.split("-")[1];
                    var returnValue = (parseInt(slotA) > parseInt(slotB)) ? 1 : -1;
                    return returnValue
                });
            }
        }
        return (
            this.props.repickPutawayActive
                ?   
                <RepickPutaway
                    repicks={repicks}
                    assignRepickToSlot={this.props.assignRepickToSlot}
                    repickPutawayBack={this.props.repickPutawayBack}
                    endSessionSummary={this.props.endSessionSummary}
                    completedRepicks={this.props.completedRepicks}
                />
                :
                <ShipGroups
                    shipGroups={shipGroups}
                    putawayRepick={this.props.putawayRepick}
                    endSessionSummary={this.props.endSessionSummary}
                    hasRepicks={repicks.length > 0}

                />
        );
    }
}
